module.exports = __webpack_public_path__ + "img/ĐIỀU KHOẢN HOÃN HỦY SÂN GOLF-0.ba399fc9.jpg";